import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { searchUsers } from '../../../../utils/http';


const { Option } = Select;

export const UsersSelect = ({ onAddNewUser, onUserSelect, selectedUser }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const timeout = useRef(null);


  const handleSearch = async (value) => {
    setSearchValue(value);

    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    if (value.length < 3) return;

    timeout.current = setTimeout(async () => {
      const resp = await searchUsers(value);
      setOptions(resp.payload);
    }, 500);
  };

  useEffect(() => {
    if (selectedUser) {
      const optionsClone = structuredClone(options);

      const isInList = optionsClone.some((u) => u.id === selectedUser.id);
      if (!isInList) {
        optionsClone.push(selectedUser);
        setOptions(optionsClone);
      }

      setSearchValue(`${selectedUser.shortName} (${selectedUser.firstName} ${selectedUser.lastName})`);
    }
  }, [selectedUser]);

  return (
    <Select
      style={{
        width: '100%',
        backgroundColor: '#fff',
      }}
      showSearch
      notFoundContent={<span>Ничего не найдено</span>}
      placeholder="Поиск по пользователям"
      open={showDropdown}
      onDropdownVisibleChange={(visible) => setShowDropdown(visible)}
      onSearch={handleSearch}
      searchValue={searchValue}
      value={selectedUser}
      onChange={(value) => onUserSelect(JSON.parse(value))}
      filterOption={false}
      dropdownRender={(menu) => (
        <div>
          {menu}
          <div>
            <Button type="text" icon={<PlusOutlined />} onClick={onAddNewUser}>
              Добавить нового пользователя
            </Button>
          </div>
        </div>
      )}

    >
      {options.map((user) => (
        <Option key={user.id} value={JSON.stringify(user)}>
          {`${user.shortName} (${user.firstName} ${user.lastName})`}
        </Option>
      ))}
    </Select>
  );
};

UsersSelect.propTypes = {
  onAddNewUser: PropTypes.func.isRequired,
  onUserSelect: PropTypes.func.isRequired,
  selectedUser: PropTypes.shape().isRequired,
};
